var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuUserManagementNormal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_menu_user_management_normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_menu_user_management_normal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-7",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    cx: 10.5,
    cy: 9.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,15 L13.9,15 C16.7166522,15 19,17.2833478 19,20.1 L19,21 L2,21 L2,20.1 C2,17.2833478 4.28334778,15 7.1,15 Z M7,16 C4.790861,16 3,17.790861 3,20 L18,20 C18,17.790861 16.209139,16 14,16 L7,16 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.499788,9.45856756 C14.6637103,9.4860452 14.8308284,9.5 15,9.5 C16.6568542,9.5 18,8.15685425 18,6.5 C18,4.84314575 16.6568542,3.5 15,3.5 C13.5847753,3.5 12.3847301,4.48470406 12.0766028,5.82266201 C13.5117434,6.43764407 14.4833464,7.8520038 14.499788,9.45856756 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2422255,11 L17.8,11 C20.1195959,11 22,12.8804041 22,15.2 L22,16 L8,16 L8,15.2 C8,14.2558048 8.31156599,13.3843798 8.83749573,12.6829271 C9.14687004,12.8059943 9.47312061,12.8957326 9.81181393,12.9477088 C9.30834961,13.484297 9,14.2061391 9,15 L21,15 C21,13.3431458 19.6568542,12 18,12 L13.3286672,12 C13.681012,11.7148829 13.9894416,11.3776394 14.2422255,11 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuUserManagementNormal);
export default __webpack_public_path__ + "sanerret-static/media/ic_menu_user_management_normal.0d614cdd54371624d755c815cbbabca6.svg";
export { ForwardRef as ReactComponent };